import * as React from "react";


const PageTitle = (props) => (
  <span className={`page__title ${props.classes ? props.classes : ""}`}>
    {props.children}
  </span>
);

export default PageTitle;



// WEBPACK FOOTER //
// ./src/theme/PageTitle.js